// extracted by mini-css-extract-plugin
export default {"single-auto-complete":"single-auto-complete--p73sKwWRy8","singleAutoComplete":"single-auto-complete--p73sKwWRy8"};